/**
 * Mock Data Service
 * Provides sample data for development and demonstration
 */

export const mockDishes = [
  {
    id: 'dish1',
    name: 'Margherita Pizza',
    dishType: 'Pizza',
    cuisine: 'Italian',
    restaurantName: 'Bella Italia',
    location: 'New York, NY',
    imageUrl: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400',
    averageRating: 4.8,
    totalRatings: 45,
    voteCount: 128,
    description: 'The perfect balance of fresh mozzarella, sweet tomato sauce, and aromatic basil. The crust is thin and crispy with just the right amount of char. This is what pizza dreams are made of!',
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish2',
    name: 'Classic Cheeseburger',
    dishType: 'Burger',
    cuisine: 'American',
    restaurantName: 'Burger Palace',
    location: 'Los Angeles, CA',
    imageUrl: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=400',
    averageRating: 4.6,
    totalRatings: 32,
    voteCount: 89,
    description: 'Juicy, perfectly seasoned patty with melty cheese. The bun is soft and buttery, and the fresh vegetables add the perfect crunch. This burger hits all the right notes!',
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish3',
    name: 'Salmon Sushi Platter',
    dishType: 'Sushi',
    cuisine: 'Japanese',
    restaurantName: 'Sakura Sushi',
    location: 'San Francisco, CA',
    imageUrl: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=400',
    averageRating: 4.9,
    totalRatings: 28,
    voteCount: 156,
    description: 'Incredibly fresh salmon that melts in your mouth. The rice is perfectly seasoned and the presentation is beautiful. Each piece is a work of art!',
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish4',
    name: 'Tonkotsu Ramen',
    dishType: 'Ramen',
    cuisine: 'Japanese',
    restaurantName: 'Ramen House',
    location: 'Seattle, WA',
    imageUrl: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400',
    averageRating: 4.7,
    totalRatings: 38,
    voteCount: 112,
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish5',
    name: 'Spaghetti Carbonara',
    dishType: 'Pasta',
    cuisine: 'Italian',
    restaurantName: 'Trattoria Roma',
    location: 'Chicago, IL',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=400',
    averageRating: 4.5,
    totalRatings: 41,
    voteCount: 95,
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish6',
    name: 'Carnitas Tacos',
    dishType: 'Taco',
    cuisine: 'Mexican',
    restaurantName: 'El Mariachi',
    location: 'Austin, TX',
    imageUrl: 'https://images.unsplash.com/photo-1551218808-94e220e084d2?w=400',
    averageRating: 4.6,
    totalRatings: 29,
    voteCount: 78,
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish7',
    name: 'Chicken Tikka Masala',
    dishType: 'Curry',
    cuisine: 'Indian',
    restaurantName: 'Taj Mahal',
    location: 'Boston, MA',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400',
    averageRating: 4.7,
    totalRatings: 35,
    voteCount: 103,
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish8',
    name: 'Ribeye Steak',
    dishType: 'Steak',
    cuisine: 'American',
    restaurantName: 'Steakhouse Prime',
    location: 'Dallas, TX',
    imageUrl: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400',
    averageRating: 4.8,
    totalRatings: 27,
    voteCount: 134,
    createdAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish9',
    name: 'Chocolate Lava Cake',
    dishType: 'Dessert',
    cuisine: 'French',
    restaurantName: 'Le Patisserie',
    location: 'Miami, FL',
    imageUrl: 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=400',
    averageRating: 4.9,
    totalRatings: 22,
    voteCount: 67,
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish10',
    name: 'Caesar Salad',
    dishType: 'Salad',
    cuisine: 'Mediterranean',
    restaurantName: 'Garden Fresh',
    location: 'Portland, OR',
    imageUrl: 'https://images.unsplash.com/photo-1546793665-c74683f339c1?w=400',
    averageRating: 4.4,
    totalRatings: 31,
    voteCount: 56,
    createdAt: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish11',
    name: 'Pad Thai',
    dishType: 'Main Course',
    cuisine: 'Thai',
    restaurantName: 'Thai Garden',
    location: 'Denver, CO',
    imageUrl: 'https://images.unsplash.com/photo-1559314809-0d155014e29e?w=400',
    averageRating: 4.6,
    totalRatings: 33,
    voteCount: 84,
    createdAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'dish12',
    name: 'Fish & Chips',
    dishType: 'Seafood',
    cuisine: 'British',
    restaurantName: 'The Crown Pub',
    location: 'Philadelphia, PA',
    imageUrl: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=400',
    averageRating: 4.5,
    totalRatings: 26,
    voteCount: 72,
    createdAt: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000)
  }
];

export const mockRatings = [
  {
    id: 'rating1',
    dishId: 'dish1',
    userId: 'user1',
    userEmail: 'foodlover@example.com',
    foodRating: 5,
    comment: 'Absolutely perfect! The crust was crispy and the cheese was amazing.',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'rating2',
    dishId: 'dish1',
    userId: 'user2',
    userEmail: 'pizzafan@example.com',
    foodRating: 4,
    comment: 'Great pizza, really enjoyed it!',
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
  },
  {
    id: 'rating3',
    dishId: 'dish2',
    userId: 'user3',
    userEmail: 'burgerenthusiast@example.com',
    foodRating: 5,
    comment: 'Best burger I\'ve ever had! The patty was perfectly cooked.',
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000)
  }
];

export const mockVotes = [
  { dishId: 'dish1', userId: 'user1', createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000) },
  { dishId: 'dish1', userId: 'user2', createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000) },
  { dishId: 'dish2', userId: 'user1', createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000) },
  { dishId: 'dish3', userId: 'user1', createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000) }
];

// Check if we should use mock data (when Firebase has permission errors)
export const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK_DATA === 'true' || 
  (typeof window !== 'undefined' && window.location.search.includes('mock=true'));

export const getMockDishes = () => {
  return Promise.resolve(mockDishes);
};

export const getMockDish = (id) => {
  return Promise.resolve(mockDishes.find(dish => dish.id === id));
};

export const getMockRatings = (dishId) => {
  return Promise.resolve(mockRatings.filter(rating => rating.dishId === dishId));
};

export const getMockVotes = (dishId) => {
  return Promise.resolve(mockVotes.filter(vote => vote.dishId === dishId));
};

